<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Update Channel</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="updateStatusForm">
                <b-row>
                    <!-- FIELD CHANNEL NAME -->
                    <b-col cols="12">
                        <b-form-group label="Channel:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updateChannelName'"
                            >
                            <!-- {{ updatedStatusVal }} -->
                                <b-form-input
                                    v-model="form.channel_name"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <!-- FIELD HUB -->
                    <b-col cols="12" v-if="_gHlp.checkRoleType(['admin'])">
                        <b-form-group label="Hub:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: _gHlp.checkRoleType(['admin']) }"
                                :vid="'updatehubName'"
                            >
                            <el-select v-model="form.hub_id" placeholder="Select">
                                <el-option
                                v-for="hub in hubList"
                                :key="hub.hub_id"
                                :label="hub.hub_name"
                                :value="hub.hub_id">
                                </el-option>
                            </el-select>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'

export default {
    props: {
        update_channel: Boolean,
        channel_data: {
            type: Object
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    mounted(){
        // this.fetchHub()
    },
    computed: {
        show: {
            get() {
                return this.update_channel;
            },
            set(newVal) {
                this.$emit('update:update_channel', newVal);
            },
        },
        filteredStatusMain() {
            return this.main_status.filter(item => item.status_id !== this.status_data.status_id)
        }
    },
    data() {
        return {
            form: {
                channel_id: '',
                channel_name: '',
                hub_id: '',
            }
        }
    },
    async created() {
        this.$watch(
            () => this.channel_data,
            (newVal) => {
                if (newVal) {
                    this.form.channel_id = newVal.channel_id ?? '';
                    this.form.channel_name = newVal.name ?? '';
                    this.form.hub_id = newVal.hub_id ? (Number(newVal.hub_id) == 0 ? "" : Number(newVal.hub_id)) : '';
                }
            },
            { immediate: true }
        )

    },
    methods:{
        submit(){
            let formData = null
            if(_gHlp.checkRoleType(['admin'])){
                formData = {
                        'name': this.form.channel_name,
                        'hub_id': (_gHlp.checkRoleType(['admin'])) ? this.form.hub_id : null
                }
            }else{
                formData = {
                    'name': this.form.channel_name
                }
            }

            axios.put(services.lookup + 'channel/' + this.form.channel_id , formData, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                this.$emit('closeModal')
                this.$emit('getChannel')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        fetchHub(){
            axios.get(services.hub + 'hubs', { headers: getHeader() })
            .then(res => {
                this.hubList = res.data.data
            })
            .catch(e => {
                console.log(e)
                this.errorFunction(e)
            })
        },
    }
}
</script>